export default __webpack_public_path__ + "static/media/s4-img.9629b40f.png";